<template>
  <div id="Header">
    <v-toolbar app class="elevation-12">
      <v-toolbar-title class="headline text-uppercase">
        <a href="#Banner" v-smooth-scroll="{ duration: 500, offset: -50 }">
          <img
            Banner
            src="@/assets/Sistesi.png"
            contain
            style="height: 38px; padding-top: 7px"
          />
        </a>
      </v-toolbar-title>

      <div v-if="!validToken" class="ml-4">
        <GoogleLogin :params="params" :onSuccess="onSuccess">
          <v-btn outline color="primary">Login / Signup</v-btn>
        </GoogleLogin>
      </div>
      <v-spacer></v-spacer>
      <div class="menubar">
        <v-btn v-if="validToken" flat href="https://demo-page.sistesi.id/">
          <span class="font-weight-bold">Demo Sistesi</span>
        </v-btn>
        <v-btn
          flat
          href="#CompanyProfile"
          v-smooth-scroll="{ duration: 500, offset: -50 }"
        >
          <span class="font-weight-bold">{{ $t("aboutus") }}</span>
        </v-btn>
        <v-btn
          flat
          href="#Vision"
          v-smooth-scroll="{ duration: 500, offset: -50 }"
        >
          <span class="font-weight-bold">{{ $t("vision_and_mission") }}</span>
        </v-btn>
        <v-btn
          flat
          href="#Values"
          v-smooth-scroll="{ duration: 500, offset: -50 }"
        >
          <span class="font-weight-bold">{{ $t("why_sistesi") }}</span>
        </v-btn>
        <v-btn
          flat
          href="#Product"
          v-smooth-scroll="{ duration: 500, offset: -50 }"
        >
          <span class="font-weight-bold">{{ $t("product") }}</span>
        </v-btn>
        <v-menu bottom origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-btn
              v-if="langKey === 'id'"
              icon
              v-on="on"
              class="font-weight-bold"
            >
              {{ langKey }}
            </v-btn>
            <v-btn v-else icon v-on="on" class="font-weight-bold">
              {{ langKey }}
            </v-btn>
          </template>
          <v-list>
            <v-list-tile
              v-for="(lang, index) in langs"
              :key="index"
              @click="changeLangHandler(lang.id)"
            >
              <v-list-tile-title>{{ lang.name }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>

      <div class="menubar-mob">
        <v-btn v-if="validToken" flat href="https://demo-page.sistesi.id/">
          <span class="font-weight-bold">Demo Sistesi</span>
        </v-btn>
        <v-toolbar-side-icon @click="openMenu = true"></v-toolbar-side-icon>
      </div>
    </v-toolbar>

    <v-dialog
      v-model="openMenu"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <div class="dialog-header">
          <v-toolbar-title class="headline text-uppercase">
            <img
              src="@/assets/Sistesi.png"
              contain
              style="height: 38px; padding-top: 7px"
            />
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="btn-close" icon @click="openMenu = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </div>
        <div class="dialog-body">
          <v-btn
            flat
            href="#CompanyProfile"
            class="btn-menu"
            @click="openMenu = false"
          >
            <span>{{ $t("aboutus") }}</span>
          </v-btn>
          <v-btn flat href="#Vision" class="btn-menu" @click="openMenu = false">
            <span>{{ $t("vision_and_mission") }}</span>
          </v-btn>
          <v-btn flat href="#Values" class="btn-menu" @click="openMenu = false">
            <span>{{ $t("why_sistesi") }}</span>
          </v-btn>
          <v-btn
            flat
            href="#Product"
            class="btn-menu"
            @click="openMenu = false"
          >
            <span>{{ $t("product") }}</span>
          </v-btn>
          <br /><br />
          <span class="btn-menu">
            <v-menu bottom origin="center center" transition="scale-transition">
              <template v-slot:activator="{ on }">
                <v-btn v-if="langKey === 'id'" color="primary" v-on="on">
                  {{ langKey }}
                </v-btn>
                <v-btn v-else color="error" v-on="on">
                  {{ langKey }}
                </v-btn>
              </template>
              <v-list>
                <v-list-tile
                  v-for="(lang, index) in langs"
                  :key="index"
                  @click="
                    changeLangHandler(lang.id);
                    openMenu = false;
                  "
                >
                  <v-list-tile-title>{{ lang.name }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </span>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import store from "@/stores";
import GoogleLogin from "vue-google-login";

export default {
  components: {
    GoogleLogin,
  },
  data: () => ({
    items: [{ title: "Profile" }, { title: "Mission" }, { title: "Product" }],
    openMenu: false,
    data: {},
    token: localStorage.getItem("token"),
    langs: [
      { id: "id", name: "ID" },
      { id: "en", name: "EN" },
    ],
    params: {
      client_id:
        "946838601089-4e1e2vl541op4iu9np2nic4j7icu48h9.apps.googleusercontent.com",
    },
    renderParams: {
      width: 250,
      height: 50,
      longtitle: true,
    },
  }),
  computed: {
    langKey() {
      return store.getters.langKey;
    },
    validToken() {
      return this.token;
    },
  },
  methods: {
    onSuccess(googleUser) {
      store.commit("isLoading", true);
      this.data = googleUser.getBasicProfile();
      const getAccessToken = Object.keys(googleUser).map(
        (k) => googleUser[k].access_token
      );
      getAccessToken.map((token) => (token ? (this.token = token) : ""));
      localStorage.setItem("token", this.token);

      setTimeout(() => {
        store.commit("isLoading", false);
        window.location.href = "https://demo-page.sistesi.id/";
      }, 1000);

    },
    changeLangHandler(val) {
      if (this.langKey !== val) {
        store.commit("isLoading", true);
        store.dispatch("setLang", val);
        this.$i18n.locale = val;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.menubar-mob {
  display: none;
}
.menubar {
  display: block;
}
@media only screen and (max-width: 900px) {
  .menubar-mob {
    display: block;
  }
  .menubar {
    display: none;
  }
}

.dialog-header {
  color: black;
  padding: 15px;
  font-size: 10px;
  position: relative;
  .btn-close {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }
}

.dialog-body {
  width: 100%;
  .btn-menu {
    display: flex;
    justify-content: center;
    justify-items: center;
    span {
      padding-top: 8px;
    }
  }
}
</style>
